/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.calendar.controllers', [])

.controller('CalendarController', ['$scope', function($scope) {

    $scope.calendar = {

      init: function() {

      }

    };

    $scope.calendar.init();

}]);